module.exports = __webpack_public_path__ + "img/contracts.d9219c77.svg";